import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Therm, DonorsDelay, TeamTherm } from "../ui";
import { ErrorMessage, Spinner, LogoSmall, LogoComp, CCAMFlag } from "../elements";

const GenericOverlay = (props) => {
  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/generic/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    /* Remove for production */
    if (streamer[0] !== '') {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1]

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      return () => props.overlayStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, [])

  const { error, isLoading, cause, status, streamType } = props.overlayStore;
  //const { accessToken } = props.userStore;

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const scrollerShow = urlParams.get('scroller');
  const scrollerPosition = urlParams.get('scrollerPosition');
  const bgColor = urlParams.get('bgColor');

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div>
      {
        cause != '35' ?
          <p className="unpublished">This campaign is unpublished, retired or not a valid St. Jude campaign.</p>
          :
          status == 'published' ?
            <div className="max-overlay">

              <div className={scrollerShow === 'yes' ? 'max-overlay__left' : 'max-overlay__left small'}>
                {scrollerShow === 'yes' ?
                  <LogoComp
                    sjclass="generic"
                    plclass="hide"
                  />
                  :
                  <LogoSmall />
                }
              </div>

              <div className="max-overlay__right" style={{
                height: `${scrollerShow === 'yes' ? '' : '60px'}`
              }}>
                {scrollerShow === 'yes' && scrollerPosition === 'top' ?
                  <DonorsDelay />
                  : ''}
                {streamType === '@' ?
                  <Therm />
                  : streamType === '+' ?
                    <TeamTherm />
                    : ''}
                {scrollerShow === 'yes' && scrollerPosition === 'bottom' ?
                  <DonorsDelay />
                  : ''}
              </div>
              {bgColor === 'ccam' ? <CCAMFlag /> : ''}

            </div>
            :
            <p className="unpublished">This campaign is unpublished, retired or not a valid St. Jude campaign.</p>
      }
    </div>
  );
}

export default inject("overlayStore")(observer(GenericOverlay));
